(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["af-buying-guide"] && !Shopify.designMode) return;
  try {
    function afOpenLinkedBuyingGuide(){if(location.hash!=='#buying-guide')return;var guide=document.getElementById('buying-guide');if(guide)guide.open=true}afOpenLinkedBuyingGuide();window.addEventListener('hashchange',afOpenLinkedBuyingGuide);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["af-catalog-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.af-catalog-nav details[open]').forEach(function(item){item.open=false;item.querySelector('summary').focus()})});
document.addEventListener('click',function(event){if(event.target.closest('.af-catalog-nav'))return;document.querySelectorAll('.af-catalog-nav details[open]').forEach(function(item){item.open=false})});
  } catch(e) { console.error(e); }
})();

})();
